<template>
  <div>
    <div v-if="isWrongbranch">
      <p>No se encontró la página</p>
    </div>
    <div v-else class="custom_container" @click="hide">
      <h1 class="title">Registro de Visitantes</h1>
      <hr class="separator">
      <v-container fluid>
        <div class="form_container">
          <p class="custom_input_label">Nombre</p>
          <input type="text" v-model="form.firstName"
            class="custom_input-border custom_input-height custom_input-outline">
          <p v-show="validations.firstName === false" class="custom_error_text">Agrega un nombre válido</p>

          <p class="custom_input_label">Apellidos</p>
          <input type="text" v-model="form.lastName" class="custom_input-border custom_input-height custom_input-outline">
          <p v-show="validations.lastName === false" class="custom_error_text">Agrega un apellido válido</p>

          <p class="custom_input_label">Correo electrónico (opcional)</p>
          <input type="text" v-model="form.email" class="custom_input-border custom_input-height custom_input-outline">
          <p v-show="isValidEmail === false" class="custom_error_text">Agrega un correo válido</p>

          <p class="custom_input_label">Asunto/Departamento</p>
          <textarea class="text_area custom_input-border custom_input-outline"
            placeholder="En este espacio puedes añadir el motivo de tu visita." name="textarea"
            v-model="form.reason"></textarea>

          <div class="host_box" ref="host_box">
            <button class="host_trigger-drop" @click="show">
              <span>
                {{ selectedCollaborator === null ? 'Selecciona a quién visitas' : selectedCollaborator.name }}
              </span>
              <v-icon color="#512e6f">
                arrow_drop_down
              </v-icon>
            </button>
            <div v-show="showDrop" ref="host_content-box">
              <div class="host_content-box custom_input-border" v-show="showDrop">
                <div class="drop-box_search custom_input-border">
                  <v-icon>search</v-icon>
                  <input type="text" class="custom_input-width custom_input-height2 custom_input-outline"
                    placeholder="Buscar" @input="event => search = event.target.value">
                </div>
                <ul class="drop-box_list">
                  <li v-for="item in searchCollaborator" @click="selectHost(item)"
                    :class="`${item.isSelected ? 'list-item_selected' : ''} list-item`">
                    <span>
                      {{ item.name }}
                    </span>
                    <div v-if="item.isSelected" class="icon-round-check">
                      <v-icon class="white--text">check</v-icon>
                    </div>
                  </li>
                </ul>
                <div class="drop-host_box">
                  <div class="drop-host_box-box" @click="toggleInputHost">
                    <p class="drop-host_box-text">Si no encuentras en la lista la persona que visitas, puedes agregarlo.
                    </p>
                    <div class="drop-host_box-btn">
                      <div class="drop-host_box-icon">
                        <v-icon class="pr-2" color="white">add</v-icon>
                      </div>
                      <span>Agregar</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p v-show="validations.isValidCollabortor === false" class="custom_error_text">Selecciona a quién visitas</p>
          <div v-show="showInputHostBox" class="drop-host_box-input">
            <p class="custom_input_label">Nombre completo</p>
            <input type="text" v-model="manualHost" class="custom_input-border custom_input-height custom_input-outline">
            <p v-show="manualHost.trim() === ''" class="custom_error_text">Ingresa el nombre</p>
            <div class="drop_host-combo-btn_box">
              <button class="custom_submit_button submit_btn white--text" @click="cancelManualHost">Cancelar</button>
              <button :class="`custom_submit_button${manualHost.trim() === '' ? '-disabled' : ''} white--text`"
                @click="addManualHost">Agregar</button>
            </div>
          </div>
          <button v-show="!showInputHostBox"
            :class="`custom_submit_button${isValidForm ? '' : '-disabled'} submit_btn m-auto white--text`"
            :disabled="!isValidForm" @click="submit">Registrar</button>
        </div>
      </v-container>
    </div>
    <LoadingModal v-model="modal.isLoading"></LoadingModal>
    <ErrorModal v-model="modal.isError"></ErrorModal>
    <QrModal v-if="modal.generatedQR != ''" v-model="modal.generatedQR"></QrModal>
  </div>
</template>
<script>
import LoadingModal from './components/loading.vue';
import QrModal from './components/QrModal.vue';
import ErrorModal from './components/ErrorModal.vue';
import API from './api/VisitUnauthenticatedModule'
import { CollaboratorFabric, Collaborator, CreateHost, GenerateQrCheckIn, GeneratedCheckInResponse } from './FabricModels/FabricModels'
export default {
  components: {
    LoadingModal,
    QrModal,
    ErrorModal,
  },
  data: () => {
    return {
      isWrongbranch: false,
      uuid_branch: null,
      countDropHandler: 0,
      showDrop: false,
      showInputHostBox: false,
      manualHost: '',
      search: '',
      collaborators: [],
      modal: {
        isError: false,
        isLoading: false,
        generatedQR: '',
      },
      form: {
        firstName: null,
        lastName: null,
        email: '',
        reason: null,
      },
      validations: {
        firstName: null,
        lastName: null,
        isValidCollabortor: null,
      },
    };
  },
  methods: {
    async submit() {
      if (this.isValidForm === false) {
        return
      }

      const form = new GenerateQrCheckIn({
        ...this.form,
        reason: this.form.reason,
        type: this.selectedCollaborator.type,
        id: this.selectedCollaborator.id,
        email: this.isValidEmail === false ? '' : this.form.email
      })

      this.modal.isLoading = true
      const generateQrResponse = await this._generateQr(this.uuid_branch, form)
      if (generateQrResponse === null) {
        this.modal.isError = true
        this.modal.isLoading = false
        return
      }
      this.modal.isLoading = false


      const qrData = new GeneratedCheckInResponse(generateQrResponse)
      this.modal.generatedQR = qrData.qr;
    },
    cancelManualHost() {
      this._cleanManualHost()
      this._forceHideDrop()
      this.toggleInputHost(false)
    },
    async addManualHost() {
      if (this.manualHost.trim() === '') {
        return;
      }

      const host = new CreateHost({ name: this.manualHost })
      this.modal.isLoading = true
      const createdHost = await this._createCollaborators(this.uuid_branch, host)
      if (createdHost === null) {
        this.modal.isError = true
        return
      }

      await this._getCollaboratorsList(this.uuid_branch)
      this.selectHost(createdHost)
      this.modal.isLoading = false

      this._cleanManualHost()
      this._forceHideDrop();
    },
    _cleanManualHost() {
      this.manualHost = ''
    },
    selectHost(collaborator = new Collaborator()) {
      const localCollaborator = new Collaborator(collaborator);

      this._clearCollabs()
      this._forceHideDrop()
      this.toggleInputHost(false);

      this.collaborators = this.collaborators.map((e) => (e.id === localCollaborator.id) && (e.type === localCollaborator.type)
        ? localCollaborator.copyWith({ isSelected: !localCollaborator.isSelected })
        : e.copyWith({ isSelected: false })
      )

    },
    _clearCollabs() {
      this.collaborators = this.collaborators.map((e) => e.copyWith({ isSelected: false }))
    },
    toggleInputHost(show = true) {
      this._clearCollabs();
      this.showInputHostBox = show;
      this._forceHideDrop();
    },
    _childOf(childNode, parentNode) { while ((childNode = childNode.parentNode) && childNode !== parentNode); return !!childNode },
    hide() {
      if (!this.showDrop) {
        return
      }

      if (!this._childOf(event.target, this.$refs.host_box) && this.countDropHandler == 1) {
        this._forceHideDrop()
      }
    },
    _forceHideDrop() {
      this.showDrop = false
      this.countDropHandler = 0
    },
    show() {
      if (this.showDrop) {
        return;
      }

      if (this.manualHost !== '') {
        this.showInputHostBox = true;
      }

      this.showDrop = true;

      setTimeout(() => {
        this.countDropHandler = 1
      }, 300);
    },
    async _generateQr(uuid_branch = '', data = new GenerateQrCheckIn()) {
      try {
        const rawHost = await API.actions.generateQr(null, { uuid_branch, data })
        return new GeneratedCheckInResponse(rawHost.data);;
      } catch (error) {
        return null;
      }
    },
    async _createCollaborators(uuid_branch = '', data = new CreateHost()) {
      try {
        const rawHost = await API.actions.createCustomHost(null, { uuid_branch, data })
        return new Collaborator(rawHost.data);;
      } catch (error) {
        return null;
      }
    },
    async _getCollaboratorsList(uuid_branch = '') {
      try {
        const rawListCollabs = await API.actions.getCollaborators(null, { uuid_branch })
        this.collaborators = CollaboratorFabric({ data: rawListCollabs.data });
      } catch (error) {
        if (error.response.status === 404) {
          this.isWrongbranch = true
        }
      }
    },

  },
  async mounted() {
    this.uuid_branch = this.$route.params.uuid_branch
    await this._getCollaboratorsList(this.uuid_branch)
  },
  computed: {
    isValidForm: function () {
      const isValid = Object.values(this.validations).every((e) => e === true);
      return isValid
    },
    searchCollaborator: function () {
      if (this.search.trim() === '') {
        return this.collaborators.map((e) => e)
      }

      return this.collaborators.filter((e) => e.name.toLocaleLowerCase().includes(this.search.toLocaleLowerCase()))
    },
    selectedCollaborator: function () {
      if (this.showInputHostBox !== false) {
        return null;
      }
      const localSelectedCollaborator = this.collaborators.filter((e) => e.isSelected === true)
      if (localSelectedCollaborator.length === 0) {
        return null
      }

      return localSelectedCollaborator[0]
    },
    isValidEmail: function () {
      if (this.form.email.trim() === '') {
        this.form.email = '';
        return null
      }

      const regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
      const isValidEmail = regexEmail.test(this.form.email)

      if (!isValidEmail) {
        return false;
      }

      return null
    }
  },
  watch: {
    'form.firstName': function (currentValue, _) {
      if (currentValue === null) {
        this.validations.firstName = false;
        return
      }
      if (currentValue.trim() === '') {
        this.validations.firstName = false;
        return
      }

      this.validations.firstName = true;
    },
    'form.lastName': function (currentValue, _) {
      if (currentValue === null) {
        this.validations.lastName = false;
        return
      }
      if (currentValue.trim() === '') {
        this.validations.lastName = false;
        return
      }
      this.validations.lastName = true;
    },
    'selectedCollaborator': function (currentValue, _) {
      if (currentValue === null) {
        this.validations.isValidCollabortor = false;
        return
      }

      this.validations.isValidCollabortor = true;
    },
  }
}
</script>
<style scoped>
.custom_input_label {
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #374151;
  margin-top: 18px;
  margin-bottom: 4px;
}

.custom_error_text {
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #F44336;
  margin-bottom: 0;
}

.custom_input-outline:focus {
  outline: 0 none;
  border-color: #EF565B;
}

.custom_input-height {
  height: 45px;
}

.custom_input-height2 {
  height: 35px;
}

.custom_input-width {
  width: 100%;
}

.custom_input-border {
  border: 1px solid #D1D5DB;
  border-radius: 5px;
  width: 100%;
}

/* generic */
.custom_border_radius_5 {
  border-radius: 5px;
}

.icon-round-check {
  border-radius: 50px;
}

.m-auto {
  margin-left: auto;
  margin-right: auto;
}

/* form */
.custom_container {
  overflow: scroll;
  height: 100vh;
}

.title {
  text-align: center;
  padding-top: 40px;
  padding-bottom: 30px;
  width: 100%;
  font-size: 32px !important;
}

.separator {
  border: none;
  margin-bottom: 30px;
  height: 1px;
  background: #EF565B;
}

.form_container {
  padding-left: 15px;
  padding-right: 15px;
}

.text_area {
  width: 100%;
  height: 80px;
  resize: none;
}

.textarea::placeholder {
  opacity: 0.8;
}

/* drop box */
.host_box {
  margin-top: 10px;
  margin-bottom: 40px;
  width: 100%;
}

.host_trigger-drop {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
  border-bottom: 1px solid #D1D5DB;
}

.host_content-box {
  padding-top: 5px;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.drop-box_list {
  height: 200px;
  overflow: scroll;
  list-style: none;
  padding: 0;
}

.drop-box_list li {
  height: 30px;
  padding-left: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  contain-intrinsic-width: auto;
  contain-intrinsic-height: 30px;
  content-visibility: auto;
}

.list-item {
  color: #6B7280;
}

.list-item_selected {
  background-color: #EF565B;
  color: white;
}

.drop-host_box-box {
  display: flex;
  justify-content: center;
  height: 50px;
  align-items: center;
  border-top: 1px solid #979797;
  flex-direction: column;
  height: auto;
  padding: 20px;
}

.drop-host_box-text {
  text-align: center;
}

.drop-host_box-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #D1D5DB;
  border-radius: 3px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  padding: 5px 10px;
  border-radius: 5px;
}

.drop-host_box-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 15px;
  border-radius: 30px;
  background-color: #6B7280;
  margin-right: 5px;
}

.drop-host_box-icon i {
  padding: 0 !important;
  font-size: 15px;
  font-weight: bold;
}

.drop-box_search {
  display: flex;
}

.drop_host-combo-btn_box {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 10px;
}

.custom_submit_button-disabled,
.custom_submit_button {
  border-radius: 5px;
  padding: 10px 20px;
  background-color: #EF565B;
}

.custom_submit_button-disabled {
  background-color: #8C8C8C;
}

.submit_btn {
  display: block;
}
</style>